import { connect } from "react-redux";
import { withMessenger } from "src/modules/messenger/Provider";
import { compose } from "recompose";
import * as authSelectors from "src/modules/auth/duck/selectors";

import { receivedResponse } from "../duck/actions";
import * as selectors from "../duck/selectors";
import PairingRequester from "./PairingRequester";

function mapStateToProps(state) {
  return {
    error: selectors.getError(state),
    pairingSource: selectors.getPairingSource(state),
    response: selectors.getResponse(state),
    responder: selectors.getResponder(state),
    request: selectors.getRequest(state),
    deviceName: authSelectors.getDeviceName(state),
    familyName: authSelectors.getFamilyName(state)
  };
}

const enhance = compose(
  connect(mapStateToProps, { receivedResponse }),
  withMessenger
);

export default enhance(PairingRequester);
